import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from '@/views/Dashboard.vue'
import RouteLink from '@/interfaces/app/RouteLink'
import store from '@/store'
import { ValuationStepName } from '@/interfaces/valuation/ValuationStep'

Vue.use(Router)

const stepNames = Object.values(ValuationStepName).join('|')
const router = new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      meta: {
        title: 'Dashboard',
        requiresAuth: true,
      },
    },
    {
      path: `/valuation/:stepName(${stepNames})?`,
      name: 'valuation',
      component: () => import('@/views/Valuation.vue'),
      meta: {
        title: 'Valuace',
        requiresAuth: true,
      },
    },
    {
      path: `/duplicate/:id`,
      name: 'valuation-duplicate',
      component: () => import('@/views/Valuation.vue'),
      meta: {
        title: 'Valuace',
        requiresAuth: true,
      },
    },
    {
      path: '/history/:type(concepts)?',
      name: 'history',
      component: () => import('@/views/History.vue'),
      meta: {
        title: 'Historie',
        requiresAuth: true,
      },
    },
    {
      path: '/report/:id',
      name: 'report',
      component: () => import('@/views/Report.vue'),
      meta: {
        title: 'Report',
        requiresAuth: true,
      },
    },
    {
      path: '/detail/:transaction',
      name: 'detail',
      component: () => import('@/views/Detail.vue'),
      meta: {
        title: 'Detail',
        requiresAuth: true,
      },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: {
        title: 'Login',
        layout: 'auth',
      },
    },
    {
      path: '*',
      redirect: 'valuation',
    },
    // {
    //   path: '*',
    //   component: () => import('@/views/404.vue'),
    //   meta: {
    //     title: '404',
    //     layout: 'empty',
    //   },
    // },
  ],
})

router.beforeEach((to, from, next) => {
  document.title = `${to.meta.title} | Valuátor 2.0`

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters['user/isLoggedIn']) {
      next()
      return
    }
    next({ name: 'login' })
  } else {
    next()
  }
})

export const menuLinks: RouteLink[] = [
  // {
  //   title: 'Dashboard',
  //   name: 'dashboard',
  //   icon: 'fa-th-large',
  // },
  {
    title: 'Nová valuace',
    name: 'valuation',
    icon: 'fa-calculator',
    childRoutes: [
      {
        title: 'Typ nemovitosti',
        name: 'valuation',
        order: 1,
        params: { stepName: ValuationStepName.Property },
      },
      {
        title: 'Údaje o budově',
        name: 'valuation',
        order: 2,
        params: { stepName: ValuationStepName.Building },
      },
      {
        title: 'Lokalita',
        name: 'valuation',
        order: 3,
        params: { stepName: ValuationStepName.Locality },
      },
      {
        title: 'Údaje o jednotce',
        name: 'valuation',
        order: 4,
        params: { stepName: ValuationStepName.Unit },
      },
    ],
  },
  {
    title: 'Historie',
    name: 'history',
    icon: 'fa-history',
    childRoutes: [
      {
        title: 'Vytvořené valuace',
        name: 'history',
        params: { type: undefined },
      },
      {
        title: 'Koncepty',
        name: 'history',
        params: { type: 'concepts' },
      },
    ],
  },
]

export default router
